import { render, staticRenderFns } from "./AppAutoupdate.vue?vue&type=template&id=0ffdce79&"
import script from "./AppAutoupdate.vue?vue&type=script&lang=js&"
export * from "./AppAutoupdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports